import { render } from "./alert.vue?vue&type=template&id=5e24feb5&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=5e24feb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e24feb5"]])

export default __exports__